import React from 'react'
import ReactDOM from 'react-dom'
import App from './jsx/App'

document.addEventListener("touchstart", function(){}, true)

ReactDOM.render(<App />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js